import React, { useState } from 'react';
import Bg2 from '../../images/shapes/btn_mask_bg.png';
import Modal from '../Modal/Modal';
import aboutImage from "../../images/about/about.webp";
import shapeNetImage from "../../images/shapes/shape_net.svg";
import { Link } from 'react-scroll';

const AboutSection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    return (
        <>
            <section id="id_about_memecoin_section" className="about_memecoin_section py-5 section_decoration">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mb-0 mb-lg-0">
                            <div className="memecoin_heading_block mb-0" data-aos="fade-up" data-aos-duration="800">
                                <h2 className="heading_text text-uppercase">
                                    Leading <mark>Logo Design</mark> Agency Ready to You Serve
                                </h2>
                                <p className="heading_description mb-0 pe-lg-5">
                                    Partner with Get Logo And Website now, and get a golden chance to receive all services at FLAT 50% off.
                                </p>
                            </div>
                            <div className="image_block" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                <ul className="btns_group unordered_list py-3" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
                                    <li>
                                        <Link className="memecoin_btn bg-white" to="/">
                                            <span className="btn_label">Get Started Now</span>
                                            <span className="btn_bg" style={{ maskImage: `url(${Bg2})` }}></span>
                                        </Link>
                                    </li>
                                    <li>
                                        <button className="memecoin_btn bg-light" onClick={openModal}>
                                            <span className="btn_label">Get a Free Quote</span>
                                            <span className="btn_bg" style={{ maskImage: `url(${Bg2})` }}></span>
                                        </button>
                                    </li>
                                </ul>
                                <p>Or Speak with an Expert: <Link style={{ fontWeight: 'bold' }}>(855) 720-5237</Link></p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <img src={aboutImage} className='mt-5' alt="about" style={{ float: "right" }} />
                        </div>
                    </div>
                </div>
                <div className="decoration_item shape_net_top">
                    <img src={shapeNetImage} alt="Shape Net" />
                </div>
            </section>
            {isModalOpen && <Modal onClose={closeModal} />}
        </>
    );
};

export default AboutSection;
